<template>
  <b-card
    border-variant="secondary"
    class="shadow-none mb-4"
  >
    <div
      class="demo-inline-spacing"
    >
      <b-avatar
        v-for="i, k in 10"
        :key="k"
        rounded
        size="30"
        variant="success"
        style="margin: 2px;"
      >
        {{ i }}
      </b-avatar>
    </div>
  </b-card>
</template>

<script>
import { BAvatar, BCard } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
    BCard,
  },
}
</script>
